import styled from 'styled-components/macro'
import { media } from '../../../utils/styles'

const Fieldset = styled.fieldset`
  display: block;
  border: 0;
  margin: 1.75em 0 0;
  padding: 0.01em 0 0 0;
  min-width: 0;

  ${media('tablet')`
    margin-left: 1.5em;
    margin-right: 1.5em;
  `}

  legend {
    display: table;
  }

  body:not(:-moz-handler-blocked) & {
    display: table-cell;
  }
`

export default Fieldset
